import create from '../creator'
import SidMessage from '@/dto/SidMessage'

const initialState = () => ({
  message: {
    instruction: {
      messageId: null,
      message: null,
      isProcessing: false,
    },
    request: {
      messageId: null,
      message: null,
      isProcessing: false,
    },
    sidMessage: new SidMessage({}),
  },
})

const _state = initialState()

const actions = {
  setRequest({ commit }, request) {
    commit('updateRequest', request)
  },
  setInstruction({ commit }, instruction) {
    commit('updateInstruction', instruction)
  },
  setSidMessage({ commit }, sidMessage) {
    commit('updateSidMessage', sidMessage)
  },
}

const mutations = {
  updateRequest(state, request) {
    state.message = {
      ...state.message,
      request,
    }
  },
  updateInstruction(state, instruction) {
    state.message = {
      ...state.message,
      instruction,
    }
  },
  updateSidMessage(state, sidMessage) {
    state.message = {
      ...state.message,
      sidMessage,
    }
  },
}

const _getters = {
  request: (state) => {
    return state.message.request
  },
  instruction: (state) => {
    return state.message.instruction
  },
}

export default create(
  {
    namespaced: true,
    state: _state,
    actions,
    mutations,
    getters: _getters,
  },
  initialState()
)
